import indexCigars from "@/assets/clients/index-cigars.png";
import lornaJane from "@/assets/clients/lorna-jane.png";
import ringersWestern from "@/assets/clients/ringers-western.png";
import universalCoin from "@/assets/clients/universal-coin.png";
import americanCoin from "@/assets/clients/american-coin.png";
import firstFidelity from "@/assets/clients/first-fidelity.png";

const ClientSpotlight = () => {
  const clients = [
    { name: "The Index", logo: indexCigars },
    { name: "Lorna Jane", logo: lornaJane },
    { name: "Ringers Western", logo: ringersWestern },
    { name: "Universal Coin & Bullion", logo: universalCoin },
    { name: "1st American Coin", logo: americanCoin },
    { name: "First Fidelity Reserve", logo: firstFidelity },
  ];

  return (
    <section className="relative py-14 px-4 overflow-hidden" aria-label="Client testimonials and statistics">
      {/* Subtle Background */}
      <div className="absolute inset-0 bg-muted/30" aria-hidden="true" />
      <div className="absolute top-0 left-0 md:left-1/4 w-32 h-32 md:w-64 md:h-64 bg-primary/5 rounded-full blur-3xl" aria-hidden="true" />
      <div className="absolute bottom-0 right-0 md:right-1/4 w-32 h-32 md:w-64 md:h-64 bg-accent/5 rounded-full blur-3xl" aria-hidden="true" />
      
      <div className="container mx-auto relative z-10">
        <header className="text-center mb-8">
          <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
            Trusted by Industry Leaders
          </h2>
        </header>

        {/* Logos Grid - Clean and Minimal */}
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-6 items-center justify-items-center" role="list" aria-label="Client logos">
            {clients.map((client, index) => (
              <div
                key={index}
                className="group relative"
                role="listitem"
              >
                <img
                  src={client.logo}
                  alt={`${client.name} - Trusted client using Ommni commerce operations platform`}
                  className={`${client.name === "Lorna Jane" ? "h-14 w-30" : "h-7 w-22"} object-contain opacity-60 group-hover:opacity-100 transition-all duration-300 filter grayscale group-hover:grayscale-0`}
                  loading="lazy"
                  width={client.name === "Lorna Jane" ? 120 : 88}
                  height={client.name === "Lorna Jane" ? 56 : 28}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Stats or Social Proof */}
        <aside className="mt-8 flex flex-wrap justify-center items-center gap-4 md:gap-6 text-center" aria-label="Platform statistics">
          <div className="space-y-0.5">
            <p className="text-xl md:text-2xl font-bold text-primary" aria-label="100 plus integrations">100+</p>
            <p className="text-xs text-muted-foreground">Integrations OOTB</p>
          </div>
          <div className="h-6 w-px bg-border hidden md:block" aria-hidden="true" />
          <div className="space-y-0.5">
            <p className="text-xl md:text-2xl font-bold text-primary" aria-label="99.9 percent uptime">99.9%</p>
            <p className="text-xs text-muted-foreground">Uptime SLA</p>
          </div>
          <div className="h-6 w-px bg-border hidden md:block" aria-hidden="true" />
          <div className="space-y-0.5">
            <p className="text-xl md:text-2xl font-bold text-primary" aria-label="24/7 support">24/7</p>
            <p className="text-xs text-muted-foreground">Support Available</p>
          </div>
        </aside>
      </div>
    </section>
  );
};

export default ClientSpotlight;
